export const UserRole = {
  CUSTOMER: "customer",
  ADMIN: "admin",
  SUPER_ADMIN: "super_admin",
  HAS_DELIVERIES: "hasDeliveries",
  CUSTOMER_OF_CUSTOMER: "customerOfCustomer"
}



// WEBPACK FOOTER //
// ./src/enums/UserRole.js